import React from 'react';
import { FiMenu, FiX } from 'react-icons/fi';
import { SALON_NAME } from '../services/api';

export default function EngagementHeader({ onToggleSidebar, sidebarOpen, pageTitle }) {
  return (
    <div className="header-shell w-full">
      <div className="header-shell__inner header-shell__inner--integrated flex min-h-[3.25rem] w-full flex-wrap items-center gap-2 px-1 py-1 md:min-h-[3.5rem] md:gap-3 lg:h-14 lg:flex-nowrap lg:px-2">
        <div className="header-shell__left flex min-w-0 flex-1 items-center gap-3">
          {typeof onToggleSidebar === 'function' ? (
            <button
              type="button"
              className="header-menu-btn lg:hidden"
              aria-label={sidebarOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={sidebarOpen}
              onClick={onToggleSidebar}
            >
              {sidebarOpen ? <FiX size={18} /> : <FiMenu size={18} />}
            </button>
          ) : null}
          <div className="min-w-0">
            <p className="portal-page-head__eyebrow mb-0 hidden sm:block">Customer engagement</p>
            <h1 className="portal-page-head__title truncate text-lg md:text-xl mb-0">
              {pageTitle || 'Dashboard'}
            </h1>
          </div>
        </div>
        <div className="header-shell__actions ml-auto text-sm text-[var(--portal-muted)] hidden sm:block">
          {SALON_NAME}
        </div>
      </div>
    </div>
  );
}
